import {storeInstance} from '@aofl/store/dist/legacy';
import {deepAssign} from '@aofl/object-utils';
import {
  sdoNs,
  dynamicPages,
  permissions,
} from '@modules/constants-enumerate';

const sdo = {
  namespace: sdoNs.GROUP_SUMMARIES,
  mutations: {

    /**
     *
     * @param {Object} payload
     * @return {Object}
     */
    init(payload) {
      return Object.assign({
        loading: true,
        summary: {},
        groupInfo: {},
      }, payload);
    },
  },
  decorators: [
    (nextState) => { // $summary
      const nextSubState = nextState[sdoNs.GROUP_SUMMARIES];
      const state = storeInstance.getState();
      const subState = state[sdoNs.GROUP_SUMMARIES];

      if (typeof nextSubState.$summary === 'undefined' ||
          nextSubState.summary !== subState.summary ||
          nextSubState.groupInfo !== subState.groupInfo ||
          nextState[sdoNs.SESSION].settings.tier_structure !== state[sdoNs.SESSION].settings.tier_structure) {
        const tiers = nextState[sdoNs.SESSION].settings.tier_structure.labels;
        const classLevel = nextState[sdoNs.SESSION].$classLevel;
        const $summary = [];
        const path = nextSubState.groupInfo.path + nextSubState.groupInfo.id + '.';
        if (nextSubState.summary?.groups) {
          for (let i = nextSubState.groupInfo.level + 1; i < nextState[sdoNs.SESSION].$classLevel; i++) {
            const tierLabel = tiers[i - 2];
            const summaryItem = {
              type: 'group-' + i,
              label: tierLabel,
              qty: nextSubState.summary.groups[i] || 0,
              urls: {
                create: dynamicPages.orgGroupCreate(i, path),
                manage: dynamicPages.orgGroupSearch(i, path),
              },
              permissions: [permissions.GROUP_EDIT],
            };
            if (typeof nextSubState?.summary?.groups?.[i] !== 'undefined') {
              summaryItem.qty = nextSubState.summary.groups[i];
            }
            $summary.push(summaryItem);
          }
        }
        if (nextSubState.groupInfo.level !== classLevel) {
          $summary.push({
            type: 'class',
            label: 'classrooms',
            qty: nextSubState.summary.classrooms || 0,
            urls: {
              create: dynamicPages.classroomCreate(path),
              manage: dynamicPages.classroomSearch(path),
            },
            permissions: [permissions.GROUP_EDIT],
          });
        }

        $summary.push({
          type: 'student',
          label: 'students',
          qty: nextSubState.summary.students?.total,
          urls: {
            create: dynamicPages.studentCreate(path),
            manage: dynamicPages.studentSearch(path),
          },
          permissions: [permissions.STUDENT_EDIT],
        });

        $summary.push({
          type: 'teacher',
          label: 'teachers',
          qty: nextSubState.summary.teachers,
          urls: {
            create: dynamicPages.teacherCreate(path),
            manage: dynamicPages.teacherSearch(path),
          },
          permissions: [permissions.TEACHER_EDIT],
        });
        nextState = deepAssign(nextState, sdoNs.GROUP_SUMMARIES, {$summary});
      }
      return nextState;
    },
  ],
};

storeInstance.addState(sdo);
